import * as React from 'react';
import './style/index.scss';
export class SubmissionSuccessForm extends React.Component {
    render() {
        return (React.createElement(React.Fragment, null, this.renderForm()));
    }
    renderForm() {
        const confirmationMessage = 'Your support request has been submitted.';
        return (React.createElement("div", { className: "submission-success-form" },
            React.createElement("i", { className: "submission-success-form__image icon-check" }),
            React.createElement("h1", { className: "submission-success-form__header" }, "Thank you"),
            React.createElement("p", { className: "submission-success-form__sub-header" }, confirmationMessage),
            React.createElement("p", null, "You will receive an email confirmation for this request and may reply to that email with additional information regarding this ticket."),
            React.createElement("p", null,
                React.createElement("a", { id: "new-support-request", onClick: this.props.onClickNewRequest }, "Submit another request"))));
    }
}
